/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Paypal_Client_SecretInputs */

const en_admin_settings_fields_paypal_client_secret = /** @type {(inputs: Admin_Settings_Fields_Paypal_Client_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client Secret`)
};

const zh_admin_settings_fields_paypal_client_secret = /** @type {(inputs: Admin_Settings_Fields_Paypal_Client_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户端密钥`)
};

/**
* | output |
* | --- |
* | "Client Secret" |
*
* @param {Admin_Settings_Fields_Paypal_Client_SecretInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_paypal_client_secret = /** @type {((inputs?: Admin_Settings_Fields_Paypal_Client_SecretInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Paypal_Client_SecretInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_paypal_client_secret(inputs)
	return zh_admin_settings_fields_paypal_client_secret(inputs)
});
export { admin_settings_fields_paypal_client_secret as "admin.settings.fields.paypal_client_secret" }